"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guessType = exports.guessLabel = exports.defaultTabPos = void 0;
const dot = require("dot-object");
const Advert_1 = require("../model/Advert");
const SearchData_1 = require("../model/SearchData");
function defaultTabPos() {
    return SearchData_1.ADVERT_SEARCH_TAB_POSITIONS;
}
exports.defaultTabPos = defaultTabPos;
function guessLabel(data, inversed = false) {
    return (inversed) ? data.name : 'Advert';
}
exports.guessLabel = guessLabel;
function guessType(data, inversed = false) {
    let obj;
    if (typeof data._$document === "object" && data._$document === null) {
        return "post";
    }
    if (data._model === Advert_1.ADVERT_MODEL_VERSION) {
        return data.type;
    }
    if (typeof data._$document === "object") {
        obj = data._$document;
    }
    else {
        obj = data;
    }
    if (obj.type === "timeline" && dot.pick("meta_data.is_post_video", obj) === true) {
        return "video";
    }
    else if (obj.type === "timeline" && dot.pick("meta_data.is_quiz", obj) === true) {
        return "quiz";
    }
    else if (obj.type === "timeline") {
        return (dot.pick("meta_data.is_post_video", obj) === true
            || dot.pick("meta_data.is_post_video", obj) === true) ? "video" : "post";
    }
    else if (obj.type === "search" || dot.pick("meta_data.type", obj) === "search") {
        return "search";
    }
    else if (obj.category === "ADVERT" && dot.pick("meta_data.is_post_video", obj) === true) {
        return "video";
    }
    else if (obj.category === "ADVERT" && dot.pick("meta_data.is_quiz", obj) === true) {
        return "quiz";
    }
    else if (obj.category === "STORY") {
        return "story";
    }
    else if (obj.category === "ADVERT") {
        return "post";
    }
    else {
        return "post";
    }
}
exports.guessType = guessType;
//# sourceMappingURL=guessers.js.map